<template>

<div>
  <PageTitle :route="$route">
    <template slot="action-button">
      <ActionButton
        icon="fa-plus"
        v-on:click="onClickButton"
      />
    </template>
  </PageTitle>

  <PageRowWrapper>
    <div class="col-sm-12">
      <LinkVehicleAndAreaGenerateEventsList />
    </div>
  </PageRowWrapper>
</div>

</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import LinkVehicleAndAreaGenerateEventsList from '@/components/settings/arena/link-vehicle-and-area-generate-events/LinkVehicleAndAreaGenerateEventsList'
import ActionButton from '@/components/button/ActionButton'

export default {
  name: 'Company',
  components: {
    PageTitle,
    ActionButton,
    PageRowWrapper,
    LinkVehicleAndAreaGenerateEventsList
  },
  methods: {
    onClickButton (e) {
      this.$router.push({ name: 'addarenalinkvehicleandareagenerateevents' })
    }
  }
}
</script>
